import { render } from "./tpl_top_one_bottom_two.vue?vue&type=template&id=8f4be6b4&scoped=true"
import script from "./tpl_top_one_bottom_two.vue?vue&type=script&lang=js"
export * from "./tpl_top_one_bottom_two.vue?vue&type=script&lang=js"

import "./tpl_top_one_bottom_two.vue?vue&type=style&index=0&id=8f4be6b4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4be6b4"],['__file',"src/views/dragger/template/tpl_top_one_bottom_two.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f4be6b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f4be6b4', __exports__)) {
    console.log('reload')
    api.reload('8f4be6b4', __exports__)
  }
  
  module.hot.accept("./tpl_top_one_bottom_two.vue?vue&type=template&id=8f4be6b4&scoped=true", () => {
    console.log('re-render')
    api.rerender('8f4be6b4', render)
  })

}


export default __exports__